/**
 * Object holding hec values for theme colors
 */
export const COLORS = {
  bluePrimary: "#305ea9",
  bluePrimaryhover: "#436aa8",
  lightBluePrimary: "#1c97c9",
  lightBluePrimaryhover: "#1880a8",
  superlightBluePrimary: "#6ccdef",
  darkBluePrimary: "#24264f",
  greenPrimary: "#308144",
  purplePrimary: "#685990",
  offwhitePrimary: "#ececec",
  greyPrimary: "#555555",
  greenSecondary: "#8dba38",
  yellowSecondary: "#f4db4e",
  pinkSecondary: "#f453aa",
  orangeSecondary: "#f9965e",
  redSecondary: "#fc4d4d",
  lightBlueSecondary: "#eff5f8",
  lightBlueSecondaryHover: "#e1eef5",
  blueBackground: "#dee5f1",
  greySecondary: "#f3f3f3",
  blueBorder: "#e1e8f2",
};

/**
 * Object colors 
 */
const COUTNRY_COLORS = {
  LAC: "#000000",
  Argentina: "#74ACDF",
  Bahamas: "#2E778C",
  Barbados: "#FFC726",
  Belice: "#171696",
  Bolivia: "#367634",
  Brasil: "#479C3B",
  Caribe: "#A0D5CE",
  Chile: "#CE3A28",
  Colombia: "#FAD149",
  "Costa Rica": "#CF302B",
  "Rep. Dom.": "#042D62",
  Ecuador: "#452C25",
  España: "#D31119",
  Guatemala: "#4898D1",
  Guyana: "#6cb36d",
  Haití: "#1E438A",
  Honduras: "#0F52BA",
  Jamaica: "#000000",
  México: "#2C6947",
  Panamá: "#DD6E6A",
  Perú: "#671815",
  Paraguay: "#6A016A",
  Suriname: "#357A3D",
  "El Salvador": "#8cf0f5",
  Uruguay: "#0038A8",
  Nicaragua: "#0067C7",
  "Trinidad y Tobago": "#000000",
  Venezuela: "#FAD149",
  Belize: "#171696",
  Brazil: "#479C3B",
  Caribbean: "#A0D5CE",
  "Dom. Rep.": "#042D62",
  Spain: "#D31119",
  Haiti: "#1E438A",
  Mexico: "#2C6947",
  Panama: "#DD6E6A",
  Peru: "#671815",
  "Trinidad and Tobago": "#000000",
};

/**
 *
 * @returns Array with one color in HEX format
 */
export const getSingleLineColors = () => [COLORS.bluePrimary];

/**
 *
 * @returns Array with two colors in HEX format
 */
export const getTwoLineColors = () => [
  COLORS.greenPrimary,
  COLORS.purplePrimary,
];

/**
 *
 * @returns Array with three colors in HEX format
 */
export const getThreeLineColors = () => [
  COLORS.greenPrimary,
  COLORS.lightBluePrimary,
  COLORS.purplePrimary,
];

/**
 *
 * @returns Array with two colors in HEX format for countries lines
 */
export const getTwoCountriesColors = () => ["black", COLORS.greenPrimary];

/**
 *
 * @param {Array <string>} countries Array of countries
 * @param {string} firstColor First color string in HEX format
 * @returns
 */
export function getCountryColorList(countries, firstColor) {
  return countries.map((c) => {
    if (c === "LAC") return firstColor;
    return COUTNRY_COLORS[c];
  });
}
